import { useCallback } from 'react';
import { QueryKeyBuilder } from '../../shared/filter/useAggregationsQuery';
import { FetchAggregations } from '../../api/listContent/fetchAggregations';
import { fetchSelectionListAggregations } from '../../api/selection-list/fetchSelectionListAggregations';
import { GroupBy } from '../../store/constants';
import { browserClient } from '../../react-query';

const SELECTION_LIST_QUERY_KEY = ['selectionListPage', 'aggregations'];

export const useSelectionListAggregations = (id: string, parsedGrouping: { key: GroupBy; id: string | null }) => {
    const aggregationsQueryKeyBuilder = useCallback<QueryKeyBuilder>(
        ({ filters, expandedFilterGroups }) => {
            return [...SELECTION_LIST_QUERY_KEY, id, filters, parsedGrouping, expandedFilterGroups];
        },
        [id, parsedGrouping]
    );
    const fetchAggregations = useCallback<FetchAggregations>(
        options =>
            fetchSelectionListAggregations({
                ...options,
                listId: id,
                groupType: parsedGrouping.key,
                groupId: parsedGrouping.id
            }),
        [id, parsedGrouping.id, parsedGrouping.key]
    );

    return { aggregationsQueryKeyBuilder, fetchAggregations };
};

export const invalidateSelectionListAggregations = (listId: string) => {
    return browserClient.invalidateQueries({ queryKey: [...SELECTION_LIST_QUERY_KEY, listId] });
};
